import { useQuery } from "@tanstack/react-query";
import { Material } from "../types";
import { get } from "../services/restClient";
import { Endpoint, setEndpoint } from "../services/endpoints";
import { queryClient } from "../hooks/queryClient";

const materialKeys = {
    all: ["material"] as const,
    lists: () => [...materialKeys.all, "list"] as const,
    list: (filters: string) => [...materialKeys.lists(), { filters }] as const,
    details: () => [...materialKeys.all, "detail"] as const,
    detail: (id: string) => [...materialKeys.details(), id] as const,
};

const getProductMaterials = async () => {
    const data = await get<Material[]>(setEndpoint(Endpoint.materials), {
        requireAuth: true,
    });
    console.log("data", data);
    return data;
};

export const useGetMaterials = () => {
    return useQuery({ queryKey: ["material"], queryFn: () => getProductMaterials() });
};

export const prefetchProductMaterials = () => {
    return queryClient.prefetchQuery({
        queryKey: ["material"],
        queryFn: () => getProductMaterials(),
    });
};
